<div class="size-selector placeholder-glow">

  @if(pdpService.showGlobaAreaSizes){
  @for (size of pdpService.sizeCounters(); track $index) {
  <button class="btn btn-secondary" [class.selected]="size.sapCode === sapCode" [class.light]="size.counter === 0 && !!pdpService.selectedArea()"
    [disabled]="loading" (click)="handleSelectSize.emit(size.sapCode)" [class.placeholder]="loading">
    {{size.size}}
    <!-- <br>
    aaa
    <br>
    {{size.counter}} -->
  </button>
  }
  }@else {
  @for (size of sizes; track $index) {
  <button class="btn btn-secondary" [class.selected]="size.sapCode === sapCode" [class.light]="size.counter === 0"
    [disabled]="loading" (click)="handleSelectSize.emit(size.sapCode)" [class.placeholder]="loading">
    {{size.size}}
    <!-- <br>
    {{size.counter}} -->
  </button>
  }
  }

</div>
